'use strict';

window.CFC = window.CFC || {};

window.CFC.GroceryList = (function($) {
  var idx = 0;
  var focusedElementAfterClose = null;
  var prevFbAsyncInit = null;
  var fbInitted = false;
  var fbPendingOps = [];
  var username;
  var loginListeners = {};

  function init() {
    var ingredientAddButtons = Array.from(document.querySelectorAll('[data-ingredient-add-recipe]'));
    
    ingredientAddButtons.forEach(btn => $(btn).on('click', initiateGroceryListClickHandler));
  }
  
  function logError(e) {
    console.error("API error: ", arguments);
  }
  
  function initiateGroceryListClickHandler(e) {
    const thisBtn = this;
    
    focusedElementAfterClose = thisBtn;
    e.preventDefault();

    loginUser(thisBtn).then(() => showGroceryListPicker(thisBtn))
      .catch(logError);
  }
  
  function get$ListPickerForm() {
    return $('#addToGrocerySubmitForm');
  }
  
  function get$IngredientCheckboxes() {
    return get$ListPickerForm().find('input[name=ingredient]');
  }
  
  function allIngredientsAreChecked() {
    return get$IngredientCheckboxes()
      .filter(function () { return !$(this).prop('checked'); })
      .length === 0;
  }
  
  function showGroceryListPicker() {
    var curIdx = idx++;

    apiGetCall('/grocerylist/getLists')
    .then(response => {
      const dialogContents = document.createElement('div');
      dialogContents.classList.add('dialog__content');
      
      dialogContents.innerHTML = `
        <div class='dialog__successWrap' style='display:none' role='alert' taborder='-1'>
          <span class='dialog__successMsg'></span>

          <div class='btnGroup dialog__successButtons'>
          </div>
        </div>
      
        <form id='addToGrocerySubmitForm'>
          <h2 tabindex="-1" class='dialog__title'>${ CFC.__esc('groceryapp.title.addToList') }</h2>

          <div class='dialog__errorWrap' style='display:none' role='alert' taborder='-1'>
            <span class='error-message'></span>
          </div>

          <div class='field groceryField--listSelect'>
            <label class="dropdownWrap" for='groceryListPicker${ curIdx }'>
              <span class="dropdownLabel" />${ CFC.__esc('groceryapp.label.selectList') }</span>
            
              <select id='groceryListPicker${ curIdx }' class='groceryListPicker' name='listId'>
                <option value="" selected>- ${ CFC.__esc('groceryapp.label.createGroceryList') } -</option>
              </select>
            </label>
          </div>
          
          <div class='field groceryField--listName'>
            <label for='groceryListNewName${ curIdx }'>${ CFC.__esc('groceryapp.label.createNewList') }</label>
            <input type='text' value='' id='groceryListNewName${ curIdx }' name='newListName' placeholder='${ CFC.__esc('groceryapp.label.newListName') }' />
          </div>

          <div class="groceryListAdd__wrap">
            <div class='groceryListAdd__allCheckField'>
              <label for="groceryListAdd_ingredientChk-all" class="groceryListAdd__ingredientWrap">
                <input type='checkbox' id='groceryListAdd_ingredientChk-all' name='all-ingredients' class='groceryListAdd__ingredientChk' checked />
                <span class='groceryListAdd__checkLabel'>${ CFC.__esc('groceryapp.label.addAllIngredients') }</span>
              </label>
            </div>
            
            <div class='groceryListAdd__ingredientList__wrapWrap'>
              <div class='groceryListAdd__ingredientList__wrap'>
                <ul class='groceryListAdd__ingredientList'>
                </ul>
              </div>
            </div>
          </div>

          <div class='btnGroup'>
            <div class='btn__wrap'>
              <button type='submit' class='btn--primary'>${ CFC.__esc('groceryapp.label.addToList') }</button>
            </div>
          </div>
          <button type='button' class='dialog-close' aria-label='${ CFC.__esc('general.close') }'>
            <img src="${ window.CFC_Vars.themeRoot }/assets/img/icon/close.svg" />
          </button>
        </form>
        `;

      const $dialogContents = $(dialogContents);
      $dialogContents.append(buildLogoutButton());
      
      const $ingredientList = $dialogContents.find('.groceryListAdd__ingredientList');
      const $listSelect = $dialogContents.find('select');
      const $form = $dialogContents.find('form');
      
      $listSelect.on('change', selectedListChanged);

      const lists = response.data.filter(list => !list.IsFavourite);
      
      lists.forEach(list => $listSelect.append($('<option></option>').text(list.Name).attr('value', list.ID)));

      const $ingredients = $('.ingredients__list .ingredient');
      let ingredientIdx = 0;

      $ingredients.each(function() {
        const chkId = `groceryListAdd_ingredientChk-${ curIdx }-${ ingredientIdx }`;
        const $ingredient = $(this);
        const $ingredientName = $ingredient.find('.ingredient__name');
        
        if (!$ingredientName.length) { return; }
        
        const amount = $ingredient.data('amount');
        const unit = $ingredient.data('unit');
        const ingredientName = $ingredientName.text();
        let ingredientAmount = '';
        
        if (amount && unit) { ingredientAmount = amount + ' ' + unit; }
        else if (amount) { ingredientAmount = amount; }
        else if (unit) { ingredientAmount = unit; }

        const $listItem = $(`<li class='groceryListAdd__ingredient'>
          <label for='${ chkId }' class="groceryListAdd__ingredientWrap">
            <input type='checkbox' name='ingredient' class='groceryListAdd__ingredientChk' id='${ chkId }' checked />
            <span class='groceryListAdd__checkLabel'></span>
          </label>
        </li>`);

        $listItem.find('.groceryListAdd__checkLabel').text(ingredientName);
        $listItem.data('amount', ingredientAmount);
        $listItem.data('name', ingredientName);
        $ingredientList.append($listItem);
        
        ingredientIdx++;
      });
      
      CFC.Common.createModal(dialogContents, focusedElementAfterClose);
      $form.on('submit', submitIngredientAdd);
      
      const $ingredientCheckboxes = $ingredientList.find('input[name=ingredient]');
      const $allCheckbox = $('input[name=all-ingredients]');
      
      $allCheckbox.on('change', function() {
        const $this = $(this);
        const isChecked = $this.prop('checked');
        $ingredientCheckboxes.prop('checked', isChecked);
      });

      $('input[name=ingredient]').on('change', function() {
        $allCheckbox.prop('checked', allIngredientsAreChecked()); 
      });
    })
    .catch(logError);
  }
  
  function selectedListChanged(e) {
    var $select = $(e.target);
    var $form = $select.closest('form');
    var $inputField = $form.find('[name=newListName]').closest('.field');
    
    // Show "New List Name" field only if "new list" is selected.
    $inputField.toggle(!$select.val());
  }
  
  function createList(listName) {
    return apiPostCall('/grocerylist/createList', { Name: listName })
      .then(response => {
        return response && response.data && response.data.ID;
      })
      .catch(() => {
        showConfirmationMessage("Error occurred.");
      });
  }
  
  async function submitIngredientAdd(e) {
    e.preventDefault();

    var $form = $(e.target);
    $form.find('[submit]').prop('disabled', true);
    let listId = $form.find('[name=listId]').val();
    let listName = $form.find('[name=listId] option:selected').text();
    
    if (!listId) {
      listName = $form.find('[name=newListName]').val();
      
      if (!listName) {
        setError($form.closest('.dialog'), window.cfctx['groceryapp.error.listNameRequired']);
        return;
      }
      
      const createListPromise = createList(listName);
      listId = await createListPromise;

      if (!listId) { 
        showConfirmationMessage("Could not create list.");
        return;
      }
    }
    
    const $checkedIngredients = $form.find('input[name=ingredient]:checked');
    const toAdd = [];
    
    $checkedIngredients.each(function() {
      const item = $(this).closest('.groceryListAdd__ingredient').data();

      toAdd.push({
        CategoryID: 'chicken.ca',
        Quantity: item.amount,
        Content: item.name
      });
    });
    
    const addRequest = { ListID: listId, Items: toAdd };

    apiPostCall('/grocerylist/addItems', addRequest)
      .then(response => {
        $form.find('[submit]').prop('enabled', true);

        const $msg = $(`<div class='groceriesAddedMessage__wrap'>
          <p class='groceriesAddedMessage'>${ CFC.__esc('groceryapp.msg.groceriesAddedToList') }</p>
          <p class='listName'>${ window._.escape(listName) }</p>
        </div>`);
          
        const $buttonGroupContents = $(`<div class='btn__wrap'>
              <a href="${ getAppDomain() }?listid=${ listId }" rel="noopener" class='button btn--primary' target="_blank">${ CFC.__esc('groceryapp.button.viewList') }</a>
              <button type='button' data-dialog-close>${ CFC.__esc('general.close') }</button>
            </div>`);

        showConfirmationMessage($msg, $buttonGroupContents); 
      })
      .catch(() => {
        $form.find('[submit]').prop('enabled', true);
        showConfirmationMessage("Error occurred.");
      });
  }
  
  function showConfirmationMessage(msg, $buttonGroupContents = null) {
    $buttonGroupContents = $buttonGroupContents || $(`<div class='btn__wrap'><button type='button'>${ CFC.__esc('general.close') }</button></div>`)

    const $dialogContent = $('.dialog__content');
    const $wrap = $dialogContent.find('.dialog__successWrap');
    
    $dialogContent.find('form').hide();
    $wrap.show();
    
    const $success = $dialogContent.find('.dialog__successMsg');
    const $msg = (msg instanceof jQuery) ? msg : $('<span />').text(msg);
    
    
    $wrap.find('.dialog__successButtons').html($buttonGroupContents);
    
    $success.empty().append($msg);
  }
  
  function loginUser(focusAfterClose) {
    return new Promise(resolve => {
      checkLoginStatus().then(response => {
        const isLoggedIn = (response && response.success && response.code === 'OK')

        if (isLoggedIn) {
          username = response.data && response.data.Email;
          
          if (!username || username.indexOf('@') === -1) {
            username = null;
          }
          
          resolve(true);
          return;
        }
        
        return promptLogin(focusAfterClose).then(() => loginUser(focusAfterClose).then(resolve));
      })
    });
  }
  
  function fbAsyncInit() {
    if (fbInitted) { return; }
    fbInitted = true;
    
    if (prevFbAsyncInit) {
      prevFbAsyncInit();
    }
    
    const fbInitOptions = {
      appId: window.CFC_Vars.fbApiId,
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v12.0'
    };
    
    window.FB.init(fbInitOptions);
    fbPendingOps.forEach(op => op());
  }
  
  function fbLogin() {
    return new Promise(cbResolve => {
      const fnLogin = () => {
        window.FB.login(response => cbResolve(response));
      };
  
      if (!window.FB) { fbPendinOps.push(fnLogin); }
      else { fnLogin(); }
    });
  }
  
  function loadFbSdk() {
    // Store previous fbAsyncInit function
    if (window.fbAsyncInit && window.fbAsyncInit !== fbAsyncInit) { 
      prevFbAsyncInit = window.fbAsyncInit;
    }

    window.fbAsyncInit = fbAsyncInit;
    
    // If FB is already loaded, ensure it's initted
    if (window.FB) {
      fbAsyncInit();
      return;
    }
    
    // Append FBSDK script
    appendScript('https://connect.facebook.net/en_US/sdk.js');
  }
  
  function promptLogin(focusAfterClose) {
    resetLoginListeners();
    focusAfterClose = (focusAfterClose || focusedElementAfterClose);
    
    const dialogHtml = buildLoginDialog();
    const dialog = CFC.Common.createModal(dialogHtml, focusAfterClose);
    const dialogNode = dialog.dialogNode;

    loadFbSdk();
    appendScript('https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js');
    
    return new Promise((cbResolve, cbError) => {
      // General-case login response handler
      const handleLoginResponse = response => {
        const loggedIn = (response && response.success && response.code === 'OK');
        
        if (loggedIn) {
          cbResolve(true);
          return;
        }
        
        if (!response|| !response.success) {
          var message = (response && response.message) || window.cfctx['general.error'];
          setError(dialogNode, message);
        }
      }; // handleLoginResponse
  
      // Prepare FB Login button
      const fbButton = dialogNode.querySelector('.groceryListLogin__fbButton');
      const fbHandler = () => {
        fbLogin().then(response => {
          const accessToken = response && response.authResponse && response.authResponse.accessToken;
          
          if (!accessToken) { return; }
          
          apiPostCall('/user/login', { FacebookToken: accessToken })
          .then(handleLoginResponse);
        })
        .catch(cbError);
      }
    
      fbButton.addEventListener('click', fbHandler);
      loginListeners.fbButtonClick = { 'node': fbButton, 'handler': fbHandler };

      // Prepare Apple Login Button
      loginListeners.appleLoginWaiter = intervalUntil(100, () => !!window.AppleID)
        .then(() => { initAppleIdButton(dialog, handleLoginResponse); });
    
      // Prepare username/password form 
      const formSubmitHandler = (e) => {
        e.preventDefault();
        clearError(dialog);

        apiPostCall('/user/login', new FormData(e.target))
        .then(handleLoginResponse);
      };
      dialogNode.addEventListener('submit', formSubmitHandler);

      loginListeners.dialogFormSubmit = { 'node': dialogNode, 'handler': formSubmitHandler };
    });
  }
  
  function initAppleIdButton(dialog, loginResponseCallback) {
    if (!dialog) { return; }
    
    const dialogNode = dialog.dialogNode;
    if (!document.body.contains(dialogNode)) { return; }

    const appleIdNode = document.createElement('div');
    const socialButtons = dialogNode.querySelector('.groceryListLogin__btnWrap--social');
    
    appleIdNode.classList.add('groceryList__appleId');
    appleIdNode.innerHTML = '<div id="appleid-signin" class="signin-button" data-color="black" data-border="true" data-type="sign-in"></div>';
    socialButtons.append(appleIdNode);
    
    window.AppleID.auth.init({
      clientId: "ca.chicken.app",
      scope: "email",
      redirectURI: `https://${ window.location.hostname }/wp-json/cfc/v1/grocery/apple-login`,
      usePopup: true
    });
    
    const fnAppleIdSuccess = function(event) {
      const authData = event.detail.authorization;
      const idToken = authData.id_token;
      const loginParams = { AppleIdIdentityToken: idToken };

      apiPostCall('/user/login', loginParams)
        .then(loginResponseCallback);
    };
    
    const fnAppleIdFailure = function(event) {
      console.error("Apple ID login error", arguments);
    };
    
    document.addEventListener('AppleIDSignInOnSuccess', fnAppleIdSuccess);
    document.addEventListener('AppleIDSignInOnFailure', fnAppleIdFailure);
    
    loginListeners.appleIdSuccess = fnAppleIdSuccess;
    loginListeners.appleIdFailure = fnAppleIdFailure;
  }

  function clearError(dialogNode) {
    $(dialogNode).find('.error-message').text('');
    $(dialogNode).find('.dialog__errorWrap').hide();
  }
  
  function setError(dialogNode, message) {
    $(dialogNode).find('.error-message').text(message);
    $(dialogNode).find('.dialog__errorWrap').show();
  }
    
  function checkLoginStatus() {
    return apiGetCall('/user/whoami');
  }
  
  function apiGetCall(path) {
    const url = getAppDomain() + '/api/v1' + path;

    return fetch(url, {
      method: 'get',
      credentials: 'include'
    })
    .then(response => response.json());
  }
  
  function apiPostCall(path, body) {
    const url = getAppDomain() + '/api/v1' + path;
    const isObject = (Object.prototype.toString.call(body) === '[object Object]');
    
    let headers = {};

    // Objects are processed into query strings.  Otherwise, assume it's a FormData object and does not need processing
    if (isObject) {
      body  = queryStringFromObject(body);
      headers = { 'Content-Type' : 'application/x-www-form-urlencoded' };
    }
    
    const options = {
      method: 'post',
      body: body,
      credentials: 'include',
      headers: headers
    };
    
    return fetch(url, options)
    .then(response => response.json());
  }
  
  function getAppDomain() {
    return CFC.Common.enFr("https://app.chicken.ca", "https://app.poulet.ca");
  }
  
  function buildLoginDialog() {
    const emailFieldId = `groceryListLogin__email_${ idx }`;
    const pwFieldId = `groceryListLogin__pw_${ idx }`;
    idx++;
    
    const target = getAppDomain() + "/login/doLogin";
    const contentNode = document.createElement('div');
    contentNode.classList.add('dialog__content');
    contentNode.classList.add('groceryListLoginDialog');
    
    contentNode.innerHTML = `
      <form class='groceryListLogin__form' action='${ target }' method='post'>
        <h2 class='dialog__title' tabindex="-1">${ _.escape(window.cfctx['groceryapp.title.login']) }</h2>
      
        <div class='dialog__errorWrap' style='display:none' role='alert' taborder='-1'>
          <span class='error-message'></span>
        </div>
      
        <div class='groceryListLogin__field dialog__field'>
          <label for='${ emailFieldId }' class='field_label--inside'>${ CFC.__esc('groceryapp.label.email') }</label>
          <input type='email' name='Email' id='${ emailFieldId }' />
        </div>
      
        <div class='groceryListLogin__field dialog__field'>
          <label for='${ pwFieldId }' class='field_label--inside'>${ CFC.__esc('groceryapp.label.password') }</label>
          <input type='password' id='${ pwFieldId }' name='Password' />
        </div>
        
        <div class='dialog__footerLinks'>
          <a class='dialog__footerLink' target='_blank' rel='noopener' href='${ getAppDomain() }/#forgot-password'>Forgot Password?</a>
          <a class='dialog__footerLink' href='${ getAppDomain() }/#create-account' target='_blank' rel='noopener'>Create An Account</a>
        </div>
        
        <div class='groceryListLogin__btnWrap btnGroup '>
          <button type='submit' class='btn--primary'>Login</button>
        </div>
        
        <div class='groceryListLogin__btnWrap btnGroup groceryListLogin__btnWrap--social'>
          <button type="button" class="groceryListLogin__fbButton">
            <i class="fab fa-facebook"></i>
            ${ window.cfctx['login.facebook'] }
          </button>
        </div>
        
        <button class='dialog-close' aria-label='${ CFC.__esc('general.close') }'>
          <img src="${ window.CFC_Vars.themeRoot }/assets/img/icon/close.svg" />
        </button>
        
      </form>`; 

    return contentNode;
  }
  
  function buildLogoutButton() {
    const wrap = document.createElement('div');
    wrap.classList.add('dialog-logoutWrap');
    
    const btn = document.createElement('button');
    btn.classList.add('dialog-logout');
    btn.innerText = CFC.__('general.logout') + (username ? (": " + username) : '');
    
    btn.addEventListener('click', logout);
    wrap.append(btn);
    
    return wrap;
  }
  
  function logout() {
    return apiGetCall('/user/logout')
      .then(aria.closeCurrentDialog);
  }

  function queryStringFromObject(obj) {
    // Generates a function that converts an object to parameters, using the specified 
    // parentVar.  E.g. a parentVar of "book" might result in book[author]=King&book[title]=Misery
    // Will automatically generate parameter names like library[books][3][author]
    const fngenParamsFromObject = (parentVar) => {
      return (obj) => {
        const params = {};

        // If there's a parentVar, parameters will be named parentVar[paramName]
        const prefix = (parentVar ? `${ parentVar }[` : '');
        const suffix = (parentVar ? ']' : '');
        
        // Convert arrays to index-keyed objects
        if (obj instanceof Array) {
          var newObj = {};
          obj.forEach((value, idx) => (newObj[`${ idx }`] = value));
          obj = newObj;
        }
        
        Object.getOwnPropertyNames(obj).forEach(p => {
          const v = obj[p];
          const valueIsObject = (Object.prototype.toString.call(v) === '[object Object]');
          const key = `${ prefix }${ p }${ suffix }`;

          if (valueIsObject) {
            const childParams = fngenParamsFromObject(key)(v);
            Object.assign(params, childParams);
          }
          else if (v instanceof Array) {
            const childParams = fngenParamsFromObject(key)(v);
            Object.assign(params, childParams);
          }
          else {
            params[key] = v;
          }
        });
        
        return params;
      }
    };

    const params = fngenParamsFromObject()(obj);
    return new URLSearchParams(params).toString();
  }
  
  function resetLoginListeners() {
    loginListeners.appleIdSuccess && document.removeEventListener('AppleIDSignInOnSuccess', loginListeners.appleIdSuccess);
    loginListeners.appleIdFailure && document.removeEventListener('AppleIDSignInOnFailure', loginListeners.appleIdFailure);

    loginListeners.fbButtonClick && loginListeners.fbButtonClick.node.removeEventListener('click', loginListeners.fbButtonClick.handler);
    loginListeners.dialogFormSubmit && loginListeners.dialogFormSubmit.node.removeEventListener('submit', loginListeners.dialogFormSubmit.handler);
    loginListeners.appleLoginWaiter && loginListeners.appleLoginWaiter.cancel();       
    loginListeners = {};
  }
  
  function appendScript(src) {
    const scr = document.createElement( 'script' );
    scr.setAttribute('src', src);
    scr.async = true;
    scr.defer = true;
    document.body.appendChild(scr);
  }
  
  function intervalUntil(interval, fn) {
    let handle; 
    const promise = new Promise((resolve) => {
      handle = window.setInterval(() => {
        if (fn()) {
          window.clearInterval(handle);
          resolve();
        }
      }, interval);
    });
    
    promise.cancel = () => { handle && window.clearInterval(handle); }
    return promise;
  }

  $(init);
  
  return {
    getAppDomain
  }
})(jQuery);